import { DokumentDateiTyp, DokumentVorschau } from '@core/domain';
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { DokumentEmailVorschauDialog } from './DokumentEmailVorschauDialog';
import { DokumentPdfVorschauDialog } from './DokumentPdfVorschauDialog';

interface DokumentVorschauDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  preview: DokumentVorschau | null;
}

export const DokumentVorschauDialog: React.FC<DokumentVorschauDialogProps> = ({
  open,
  onOpenChange,
  preview,
}) => {
  if (!preview) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Dokumentvorschau</DialogTitle>
          </DialogHeader>
          <div className="text-sm text-muted-foreground">
            Es ist keine Vorschau verfügbar.
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <>
      {preview.type === DokumentDateiTyp.PDF && (
        <DokumentPdfVorschauDialog
          open={open}
          onOpenChange={onOpenChange}
          content={preview.content}
        />
      )}

      {preview.type === DokumentDateiTyp.HTML && (
        <DokumentEmailVorschauDialog
          open={open}
          onOpenChange={onOpenChange}
          content={preview.content}
        />
      )}
    </>
  );
};
